import { FC } from 'react'
import { Checkbox } from '@/root/ui/tuuleliinid'
import { useGetTranslations } from '@/root/shared-hooks'
import { RefundRouteInfoProps } from '@/root/shared-types'
import cn from 'classnames'
import ArrowLong from '@/icons/ArrowLong'
import { DateTime } from 'luxon'
import { CalendarIcon } from '@/root/ui/tuuleliinid/icons/CalendarIcon'
import { ClockIcon } from '@/icons/ClockIcon'

export const RefundRouteInfo: FC<RefundRouteInfoProps> = ({
  arrivalPort,
  departurePort,
  isRoundTrip,
  checked,
  disabled,
  className,
  onChange,
  departure,
  isRefund,
  isCancelled,
}) => {
  const { getTranslation } = useGetTranslations()

  const departureDate = departure ? DateTime.fromISO(departure) : null
  const formattedDate = departureDate ? departureDate.toFormat('dd.MM.yyyy') : null
  const formattedTime = departureDate ? departureDate.toFormat('HH:mm') : null

  const cancelled = isRefund || isCancelled
  const iconColor = cancelled ? 'neutral-medium-light' : 'primary-base'
  return (
    <div
      className={cn(
        'text-neutral-medium-light flex flex-col gap-3 text-lg',
        { 'text-primary-base': !cancelled },
        className
      )}
    >
      <div className="flex items-center gap-3">
        <p className="text-center">{departurePort}</p>
        <ArrowLong width={18} height={18} color={iconColor} />
        <p>{arrivalPort}</p>
      </div>
      <div className="flex gap-2">
        <CalendarIcon width={18} height={18} color={iconColor} />
        {formattedDate}
      </div>
      <div className="flex gap-2">
        <ClockIcon width={18} height={18} color={iconColor} />
        {formattedTime}
      </div>
      {cancelled && (
        <div className="flex">
          <div className="bg-error-medium-light flex gap-3 rounded-lg px-2 py-1 text-base text-white uppercase">
            {isRefund ? getTranslation('cancelled') : getTranslation('cancelledSail')}
          </div>
        </div>
      )}
      {isRoundTrip && !isRefund && (
        <Checkbox
          label={getTranslation('cancelRouteRefund')}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          variant="error"
          className="items-center font-normal text-black"
          colorLabel
        />
      )}
    </div>
  )
}
